// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import store from './vuex/store'
import VueSweetalert2 from 'vue-sweetalert2'
import Icon from 'vue-awesome/components/Icon'
import { sync } from 'vuex-router-sync'
require('../node_modules/bootstrap-sass/assets/stylesheets/_bootstrap.scss')

Vue.config.productionTip = true
Vue.use(BootstrapVue)
Vue.component('icon', Icon)
Vue.use(VueSweetalert2)
// Vue.prototype.$index = index

// this.$index.getMushroomTypeText(somedata)
sync(store, router)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js